export * from './useScope2';
